<template>
  <Map
    :key="mapKey"
    v-bind="props"
    ref="mapRef"
    @click-on-marker="useMarker"
  />
</template>

<script setup lang="ts">
  import { ref, onErrorCaptured, useTemplateRef } from 'vue';

  import Map from '@/features/SightsMap.vue';
  import { type CityTagsAdvanced, type ModalProps } from '@/shared/models/types.js';
  import debounce from '@/shared/utils/debounce';

  const mapKey = ref(1562);
  const mapReference = useTemplateRef('mapRef');

  const props = withDefaults(defineProps<ModalProps>(), {});

  const emit = defineEmits(['clickOnMarker']);

  const useZoom = () => {
    mapReference.value?.useZoom();
  };

  defineExpose({ useZoom });

  const updateMapKey = () => {
    mapKey.value = Number(new Date());
  };

  onErrorCaptured(() => {
    debounce(updateMapKey);
  });

  const useMarker = (marker: CityTagsAdvanced) => {
    emit('clickOnMarker', marker);
  };
</script>
